<template>
  <div class="staff-dimission">
    <c-table
      ref="table"
      :fields="fields"
      :columns="columns"
      url="/yuangong/resign"
      @before-fetch="beforeFetch"
    >
      <email-table-column slot="email"></email-table-column>
      <el-table-column slot="bumen" show-overflow-tooltip label="公司">
        <template v-slot="{row}">
          <span>{{row | bumen}}</span>
        </template>
      </el-table-column>
      <photo-table-column slot="photo"></photo-table-column>
    </c-table>
  </div>
</template>

<script>
import CTable from '@/components/common/table'
import mixin from '@/mixins'

export default {
  name: 'staff-dimission',
  mixins: [ mixin ],
  components: { CTable },
  data () {
    return {
      fields: [
        {
          prop: 'name',
          placeholder: '姓名/工号',
          clearable: true
        }
      ],
      columns: [
        { prop: 'id', label: '工号', width: 100 },
        { prop: 'name', label: '姓名', width: 100 },
        { slot: 'bumen' },
        { prop: 'mobile', label: '手机', width: 140 },
        { slot: 'email' },
        { prop: 'area', label: '地区' },
        { prop: 'indate', label: '入职时间', width: 110 },
        { prop: 'zhiwei', label: '职位' },
        { prop: 'level', label: '级别' },
        { prop: 'birth', label: '生日', width: 110 },
        { prop: 'xueli', label: '学历' },
        { prop: 'xuewei', label: '学位' },
        { prop: 'xuexiao', label: '学校' },
        { prop: 'zhuanye', label: '专业' },
        { slot: 'photo' }
      ]
    }
  },
  methods: {
    beforeFetch (params) {
      params.gong_id = params.name
    }
  }
}
</script>

<style lang="scss">
</style>
